export const termsLink =
    'https://static.servicetitan.com/portal/ServiceTitan_-_Interim_Customer_Portal_Terms_11.1.2020.pdf';
